// @flow
import React from 'react';

import ForcesContainer from '../containers/ForcesContainer';

const DrivingForcesContainer = () => (
  <ForcesContainer submitButtonText="Create Driving Force" driving />
);

export default DrivingForcesContainer;



// WEBPACK FOOTER //
// ./src/components/DrivingForcesContainer.js